var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('cs-preloader-overlay', {
    attrs: {
      "loading": _vm.loading
    }
  }, [_c('div', {
    staticClass: "overlay-container"
  }, [_c('modal-cabinet-qr-code'), _c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "header-container"
  }, [_c('capusta-title', {
    attrs: {
      "title": _vm.$t('ready.for.pay'),
      "icon-outside": ""
    }
  })], 1), _c('div', {
    staticClass: "form-container"
  }, [_c('div', {
    staticClass: "section-container"
  }, [_c('substrate-mount', [_c('div', {
    staticClass: "input-container"
  }, [_c('capusta-copy-field', {
    attrs: {
      "label": _vm.$t('link.to.pay'),
      "value": _vm.billParams.url
    }
  })], 1), _vm.isShownMakerPublishing ? _c('div', {
    staticClass: "switcher-container"
  }, [_c('cs-switcher', {
    attrs: {
      "label": _vm.$t('publishing.to.maker')
    },
    on: {
      "input": _vm.onToggleMarketplace
    },
    model: {
      value: _vm.onMarketplace,
      callback: function callback($$v) {
        _vm.onMarketplace = $$v;
      },
      expression: "onMarketplace"
    }
  })], 1) : _vm._e(), _vm.promoCodeApplicable ? _c('div', {
    staticClass: "switcher-container"
  }, [_c('cs-switcher', {
    attrs: {
      "label": _vm.$t('allow.promocode.usage'),
      "value": _vm.applyPromoCode
    },
    on: {
      "input": _vm.onTogglePromoCodePermission
    }
  })], 1) : _vm._e(), _vm.onMarketplace ? _c('div', {
    staticClass: "option-container",
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.onChangeMarketplaceCategory($event);
      }
    }
  }, [_c('option-panel', {
    attrs: {
      "option": _vm.currentCategory,
      "noactive": ""
    }
  }, [_c('cs-button', {
    attrs: {
      "type": "secondary"
    }
  }, [_vm._v(_vm._s(_vm.$t('common.change')))])], 1)], 1) : _vm._e(), _c('div', {
    staticClass: "input-container"
  }, [_c('input-email', {
    ref: "email",
    attrs: {
      "input-id": "input-email",
      "input-name": _vm.$t('send.to.email'),
      "input-title": _vm.$t('indicate.electronic.mail'),
      "input-header": _vm.$t('send.to.email'),
      "input-placeholder": _vm.$t('enter.email'),
      "button-text": _vm.$t('common.send'),
      "required": ""
    },
    on: {
      "buttonClicked": _vm.sendBill
    },
    model: {
      value: _vm.email,
      callback: function callback($$v) {
        _vm.email = $$v;
      },
      expression: "email"
    }
  })], 1), _c('div', {
    staticClass: "option-container"
  }, [_c('socials-share', {
    attrs: {
      "url": _vm.billParams && _vm.billParams.url,
      "description": _vm.PROJECT_INFO.description || '',
      "title": "".concat(_vm.$t('link.to.pay'), " | capusta.space")
    }
  }, [_c('button', {
    staticClass: "button social qr",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.SET_MODAL_PARAMS({
          type: 'QR',
          params: {
            show: true,
            bill: _vm.billParams,
            type: 'bill',
            code: _vm.billParams.code
          }
        });
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('get.qr')))])])])], 1)])], 1), _c('div', {
    staticClass: "button-primary-container"
  }, [_c('cs-button', {
    attrs: {
      "width": 300
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'Invoicing'
        });
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('create.new')) + " ")])], 1), _c('div', {
    staticClass: "button-secondary-container"
  }, [_c('cs-button', {
    attrs: {
      "type": "secondary",
      "width": 200
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'cabinet'
        });
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('to.main.page')) + " ")])], 1)])]), _c('cs-dialog', {
    model: {
      value: _vm.isShownMarketplaceCategories,
      callback: function callback($$v) {
        _vm.isShownMarketplaceCategories = $$v;
      },
      expression: "isShownMarketplaceCategories"
    }
  }, [_c('dialog-list-layout', _vm._l(_vm.getPreparedCategories, function (category) {
    return _c('option-panel', {
      key: category.id,
      attrs: {
        "option": category
      },
      on: {
        "click": _vm.onCloseMarketplaceCategories
      }
    });
  }), 1)], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }